
export const PrintoutSkeleton = () => {
    return null // @TODO
}
